import { render, staticRenderFns } from "./TabForm.vue?vue&type=template&id=c3dda45a&scoped=true&"
import script from "./TabForm.vue?vue&type=script&lang=js&"
export * from "./TabForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dda45a",
  null
  
)

export default component.exports